// import React from "react";
// import InputFactory from "../../../components/InputFactory";
// import { saveFileUseCase } from "../../../usecases/file";
// import { upsertUseCase } from "../../../usecases/object";

// function Collapsable({ object }) {
//   const [show, setShow] = React.useState(false);
//   const [zoomSrc, setZoomSrc] = React.useState(null);

//   // async function handleChange(value, field) {
//   //   console.log("val", value, "field", field);
//   //   const urls = Array.isArray(value) ? value : [value];
//   //   object.logsArray = urls;
//   //   console.log("AT", urls);
//   //   await upsertUseCase().execute("transactions", object);
//   // }

//   async function handleChange(value, field) {
//     console.log("val", value, "field", field);
//     // 1) flatten incoming value to an array
//     const newUrls = Array.isArray(value) ? value : [value];
//     // 2) grab any existing attachments
//     const oldUrls = Array.isArray(object.logsArray) ? object.logsArray : [];
//     // 3) merge them
//     object.logsArray = [...oldUrls, ...newUrls];
//     console.log("AT", object.logsArray);
//     await upsertUseCase().execute("transactions", object);
//   }

//   async function handleDelete(urlToDelete) {
//     console.log("url", urlToDelete);
//     // try {
//     //   // 1) delete file from storage
//     //   await deleteObjectUseCase().execute(urlToDelete);
//     //   // 2) remove it from our array
//     //   object.logsArray = object.logsArray.filter(url => url !== urlToDelete);
//     //   // 3) persist the transaction without that URL
//     //   await upsertUseCase().execute("transactions", object);
//     // } catch (err) {
//     //   console.error("Delete failed", err);
//     //   // optionally show a toast here
//     // }
//   }

//   function toggleShow() {
//     setShow((s) => !s);
//   }

//   return (
//     <div style={{ padding: 10, backgroundColor: "#f9f9f9" }}>
//       {/* … your Details list … */}
//       <b>Details:</b>
//       <ul style={{ listStyle: "none", paddingTop: "12px" }}>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Id:</span> {object?.id}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Customer Count:</span>{" "}
//           {object?.cust_count}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Customer Name:</span>{" "}
//           {object?.cust_name}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Discount Amount:</span>{" "}
//           {object?.discount_amount}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Discount Amount:</span>{" "}
//           {object?.discount_amount}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Payment Type:</span>{" "}
//           {object?.paymenttype}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Status:</span> {object?.status}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Store Code:</span>{" "}
//           {object?.store_code}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Total:</span> {object?.total}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Total Pretax:</span>{" "}
//           {object?.total_pretax}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Total Tax:</span>{" "}
//           {object?.total_tax}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Total Tax Free:</span>{" "}
//           {object?.total_taxfree}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Transaction Date:</span>{" "}
//           {object?.tran_date}
//         </li>
//         <li>
//           <span style={{ fontWeight: "bold" }}>Transaction Type:</span>{" "}
//           {object?.tran_type}
//         </li>
//       </ul>

//       <div className="mb-3">
//         <label className="form-label fw-bold">File Attachment</label>
//         <InputFactory
//           className="col-9"
//           type="MultipleFile"
//           field="shareArray"
//           saveFile={saveFileUseCase()}
//           onChange={handleChange}
//           placeholder="Enter Reason"
//           multi
//           multiple
//         />
//       </div>

//       <button
//         className="btn"
//         style={{ backgroundColor: "#83c14a", color: "white" }}
//         onClick={toggleShow}
//       >
//         {show ? "Hide" : "View"}
//       </button>

//       {show && object.logsArray ? (
//         <div style={{ marginTop: 12, display: "flex", flexWrap: "wrap" }}>
//           {object.logsArray.map((url, i) => (
//             <div
//               key={i}
//               style={{
//                 position: "relative",
//                 margin: 4,
//                 width: 120,
//                 height: 120,
//               }}
//             >
//               <img
//                 src={url}
//                 alt={`attachment-${i}`}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   border: "2px solid #ddd",
//                   borderRadius: 4,
//                   cursor: "pointer",
//                 }}
//                 onClick={() => setZoomSrc(url)}
//               />

//               {/* delete “×” button */}
//               <button
//                 onClick={() => handleDelete(url)}
//                 style={{
//                   position: "absolute",
//                   top: 4,
//                   right: 4,
//                   background: "rgba(0,0,0,0.6)",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "50%",
//                   width: 24,
//                   height: 24,
//                   lineHeight: "20px",
//                   textAlign: "center",
//                   cursor: "pointer",
//                 }}
//               >
//                 ×
//               </button>
//             </div>
//           ))}
//         </div>
//       ) : (
//         show && <p className="mt-4">No upload Image</p>
//       )}

//       {/* Zoom overlay */}
//       {zoomSrc && (
//         <div
//           onClick={() => setZoomSrc(null)}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.8)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 9999,
//             cursor: "zoom-out",
//           }}
//         >
//           <img
//             src={zoomSrc}
//             alt="zoomed"
//             style={{
//               maxWidth: "90%",
//               maxHeight: "90%",
//               boxShadow: "0 0 15px rgba(0,0,0,0.5)",
//               borderRadius: 8,
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// export default Collapsable;

import React from "react";
import InputFactory from "../../../components/InputFactory";
import { saveFileUseCase } from "../../../usecases/file";
import { upsertUseCase, deleteObjectUseCase } from "../../../usecases/object";

function Collapsable({ object }) {
  const [show, setShow] = React.useState(false);
  const [zoomSrc, setZoomSrc] = React.useState(null);
  const [pendingDeleteUrl, setPendingDeleteUrl] = React.useState(null);

  async function handleChange(value) {
    const newUrls = Array.isArray(value) ? value : [value];
    const oldUrls = Array.isArray(object.logsArray) ? object.logsArray : [];
    object.logsArray = [...oldUrls, ...newUrls];
    await upsertUseCase().execute("transactions", object);
  }

  async function handleDelete(url) {
    try {
      object.logsArray = object.logsArray.filter((u) => u !== url);
      console.log("newnew", object);
      await upsertUseCase().execute("transactions", object);
    } catch (err) {
      console.error("Delete failed", err);
    }
  }

  const payments = [
    { label: object.paymenttype, amount: object.paymenttypetotal },
    { label: object.paymenttype2, amount: object.paymenttype2total },
    { label: object.paymenttype3, amount: object.paymenttype3total },
    // add more if you ever have paymenttype4, etc.
  ].filter((p) => p.label); // drop any empty/null entries

  return (
    <div style={{ padding: 10, backgroundColor: "#f9f9f9" }}>
      {/* …Details list… */}
      <b>Details:</b>
      <ul style={{ listStyle: "none", paddingTop: "12px" }}>
        <li>
          <span style={{ fontWeight: "bold" }}>Id:</span> {object?.id}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Customer Count:</span>{" "}
          {object?.cust_count}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Customer Name:</span>{" "}
          {object?.cust_name}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Discount Amount:</span>{" "}
          {object?.discount_amount}
        </li>
        {/* <li>
          <span style={{ fontWeight: "bold" }}>Discount Amount:</span>{" "}
          {object?.discount_amount}
        </li> */}
        {/* <li>
          <span style={{ fontWeight: "bold" }}>Payment Type:</span>{" "}
          {object?.paymenttype}
        </li> */}
        <li>
          <span style={{ fontWeight: "bold" }}>Status:</span> {object?.status}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Store Code:</span>{" "}
          {object?.store_code}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Total:</span> {object?.total}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Total Pretax:</span>{" "}
          {object?.total_pretax}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Total Tax:</span>{" "}
          {object?.total_tax}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Total Tax Free:</span>{" "}
          {object?.total_taxfree}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Transaction Date:</span>{" "}
          {object?.tran_date}
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Transaction Type:</span>{" "}
          {object?.tran_type}
        </li>
      </ul>

      {/* NEW: payments table */}
      <h4>Payments</h4>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "12px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                textAlign: "left",
                borderBottom: "1px solid #ccc",
                padding: "4px",
                backgroundColor: "#83c14a",
                color: "white",
              }}
            >
              Method
            </th>
            <th
              style={{
                textAlign: "right",
                borderBottom: "1px solid #ccc",
                padding: "4px",
                backgroundColor: "#83c14a",
                color: "white",
              }}
            >
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p, i) => (
            <tr key={i}>
              <td style={{ padding: "4px", borderBottom: "1px solid #eee" }}>
                {p.label}
              </td>
              <td
                style={{
                  padding: "4px",
                  textAlign: "right",
                  borderBottom: "1px solid #eee",
                }}
              >
                {p.amount}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mb-3">
        <label className="form-label fw-bold">Image Attachment:</label>
        <InputFactory
          className="col-9"
          type="MultipleFile"
          field="shareArray"
          saveFile={saveFileUseCase()}
          onChange={handleChange}
          placeholder="Enter Reason"
          multi
          multiple
        />
      </div>

      <button
        className="btn"
        style={{ backgroundColor: "#83c14a", color: "white", marginBottom: 12 }}
        onClick={() => setShow((s) => !s)}
      >
        {show ? "Hide" : "View"}
      </button>

      {show && object.logsArray && (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {object.logsArray.map((url, i) => (
            <div
              key={i}
              style={{
                position: "relative",
                margin: 4,
                width: 120,
                height: 120,
              }}
            >
              <img
                src={url}
                alt={`attachment-${i}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  border: "2px solid #ddd",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={() => setZoomSrc(url)}
              />

              <button
                onClick={() => setPendingDeleteUrl(url)}
                style={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  background: "rgba(0,0,0,0.6)",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: 24,
                  height: 24,
                  lineHeight: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {zoomSrc && (
        <div
          onClick={() => setZoomSrc(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={zoomSrc}
            alt="zoomed"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              boxShadow: "0 0 15px rgba(0,0,0,0.5)",
              borderRadius: 8,
            }}
          />
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {pendingDeleteUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: 20,
              borderRadius: 8,
              textAlign: "center",
              maxWidth: 300,
              width: "80%",
              boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            <p>Are you sure you want to delete this image?</p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: 16,
              }}
            >
              <button
                onClick={() => {
                  handleDelete(pendingDeleteUrl);
                  setPendingDeleteUrl(null);
                }}
                className="btn btn-danger"
              >
                Yes, delete
              </button>
              <button
                onClick={() => setPendingDeleteUrl(null)}
                className="btn btn-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Collapsable;
